import Projeectt from "../components/projeect/projectt"
function Proj(){
    return(
        <>
        <Projeectt/>
        </>
    )
}
export default Proj